// The sentence of a strings table by a key that the caller builds, such
// as `topic_${t}`. It is a leaf with no import.

/**
 * The sentence of `table` at `key`, or `fallback` when the table holds no
 * plain sentence there: no key, or a sentence that takes figures (a
 * function). A key the server sends is never eaten by a missing row.
 */
export function wordOf(table: object, key: string, fallback: string): string {
  const v = (table as Record<string, unknown>)[key];
  return typeof v === 'string' ? v : fallback;
}
